import { render, staticRenderFns } from "./FamilytreeFeedback.vue?vue&type=template&id=2c329c58"
import script from "./FamilytreeFeedback.vue?vue&type=script&lang=js"
export * from "./FamilytreeFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports